module.exports = __webpack_public_path__ + "img/pc-step-5.ceb9d30c.jpg";